import { render, staticRenderFns } from "./SelectRiskScoreFilterPopup.vue?vue&type=template&id=0aef049e&scoped=true"
import script from "./SelectRiskScoreFilterPopup.vue?vue&type=script&lang=js"
export * from "./SelectRiskScoreFilterPopup.vue?vue&type=script&lang=js"
import style0 from "./SelectRiskScoreFilterPopup.vue?vue&type=style&index=0&id=0aef049e&prod&lang=scss"
import style1 from "./SelectRiskScoreFilterPopup.vue?vue&type=style&index=1&id=0aef049e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aef049e",
  null
  
)

export default component.exports